import React from "react";
import Styles from "./index.module.css";

interface InputTextProps {
  min?:number,
  id?:string,
  placeholder: string;
  style?: Object;
  type?: string;
  changeHandler?: (name?: any) => void;
  value?: string;
  defaultValue?:any;
  autoComplete?: string;
  disabled?: boolean;
  options?: {
    placeholder: string;
    value: string;
  }[];
}

function InputText({
  id,
  min,
  placeholder,
  type,
  changeHandler,
  value,
  autoComplete,
  options,
  style,
  disabled,
  defaultValue,
  ...props
}: InputTextProps) {

  const handleScroll = (e:any) => {

  e.target.blur()

  
  e.stopPropagation()

 
  setTimeout(() => {
    e.target.focus()
  }, 0)
}
  return (
    <div {...props} className={Styles.inputField}>
      {type === "textarea" ? (
        <textarea
          onChange={changeHandler}
          value={value}
          placeholder={placeholder}
          autoComplete={autoComplete}
          disabled={disabled}
        ></textarea>
      ) : type === "option" ? (
        <select
          name={placeholder}
          id={placeholder}
          onChange={changeHandler}
        >
          <option value="none" disabled hidden>
            {placeholder}
          </option>
          {options &&
            options.map((item, index) => (
              <option value={item.placeholder} key={index} selected={defaultValue===item.placeholder}>
                {item.placeholder}
              </option>
            ))}
        </select>
      ): type === "option1" ? (
        <select
          name={placeholder}
          id={placeholder}
          onChange={changeHandler}
        >
          <option value="none" disabled hidden>
            {placeholder}
          </option>
          {options &&
            options.map((item, index) => (
              <option value={item.value} key={index} selected={defaultValue===item.value}>
                {item.placeholder}
              </option>
            ))}
        </select>
      ) : type === "toggleSwitch" ? (
        <div className={Styles.toggleSwitch}>
          <label className={Styles.switch}>
            <input
              type="checkbox"
              checked={!!value}
              className={Styles.switchInput}
              onChange={changeHandler}
              disabled={disabled}
            />
            <span className={`${Styles.slider} ${Styles.round}`}></span>
          </label>
        </div>
      ) : (
        <input
          style={style}
          min={min}
          id={id}
          defaultValue={defaultValue}
          onChange={changeHandler}
          type={type ? type : "text"}
          onWheel={handleScroll}
          value={value}
          placeholder={placeholder}
          autoComplete={autoComplete}
          required
          disabled={disabled}
        />
      )}
    </div>
  );
}

export default InputText;
